export class UpdateProfileModel {
    public firstName: string = '';
    public lastName: string = '';
    public phone: string = '';
    public dateOfBirth: any = '';
  }
      